import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyAttentionData } from '../../../interfaces/metrics';

@Component({
  selector: 'bst-company-attention',
  templateUrl: './company-attention.component.html',
  styleUrls: ['./company-attention.component.scss'],
  standalone: false,
})
export class CompanyAttentionComponent {
  @Input() data!: CompanyAttentionData;
  @Output() rowSelected = new EventEmitter<{ userId: number; name: string }>();

  get rows() { return this.data?.rows ?? null; }

  select(row: { userId: number; name: string }, event: Event): void {
    event.stopPropagation();   // do not also trigger the widget-card click
    this.rowSelected.emit({ userId: row.userId, name: row.name });
  }
}
